export const FACEBOOK_PIXEL_EVENTS = {
  ADD_TO_CART: 'AddToCart',
  PURCHASE: 'Purchase',
  INITIATE_CHECKOUT: 'InitiateCheckout',
  VIEW_CONTENT: 'ViewContent',
};
